import { formAnatomy as parts } from '@chakra-ui/anatomy'
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system'
import { textStyles } from '../foundations/textStyles'
const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyleRequiredIndicator = defineStyle({
  color: 'danger.500',
  ...textStyles.md,
})

const baseStyleHelperText = defineStyle({
  color: 'hb-body-text',
  ...textStyles.sm,
})

const baseStyle = definePartsStyle({
  container: {
    width: '100%',
    position: 'relative',
    marginBottom: 4,
  },
  requiredIndicator: baseStyleRequiredIndicator,
  helperText: baseStyleHelperText,
})

export const Form = defineMultiStyleConfig({
  baseStyle,
})
